var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAscSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ascending-sort",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.5,
    height: 22.917,
    viewBox: "0 0 23.5 22.917",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8304",
    "data-name": "Path 8304",
    d: "M12.433,5.3v-.78a.78.78,0,0,0-.78-.78H.78a.78.78,0,0,0-.78.78V5.3a.78.78,0,0,0,.78.78H11.653A.78.78,0,0,0,12.433,5.3Z",
    transform: "translate(0 -3.736)",
    fill: "#3f2566"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8305",
    "data-name": "Path 8305",
    d: "M10.188,66.736H.78a.78.78,0,0,0-.78.78v.78a.78.78,0,0,0,.78.78h9.408a.78.78,0,0,0,.78-.78v-.78A.78.78,0,0,0,10.188,66.736Z",
    transform: "translate(0 -61.821)",
    fill: "#3f2566"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8306",
    "data-name": "Path 8306",
    d: "M8.723,129.736H.78a.78.78,0,0,0-.78.78v.78a.78.78,0,0,0,.78.78H8.723a.78.78,0,0,0,.78-.78v-.78A.78.78,0,0,0,8.723,129.736Z",
    transform: "translate(0 -119.906)",
    fill: "#3f2566"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8307",
    "data-name": "Path 8307",
    d: "M7.257,199.736H.78a.78.78,0,0,0-.78.78v.78a.78.78,0,0,0,.78.78H7.257a.78.78,0,0,0,.78-.78v-.78A.78.78,0,0,0,7.257,199.736Z",
    transform: "translate(0 -184.445)",
    fill: "#3f2566"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8308",
    "data-name": "Path 8308",
    d: "M5.792,262.736H.78a.78.78,0,0,0-.78.78v.78a.78.78,0,0,0,.78.78H5.792a.78.78,0,0,0,.78-.78v-.78A.78.78,0,0,0,5.792,262.736Z",
    transform: "translate(0 -242.53)",
    fill: "#3f2566"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8309",
    "data-name": "Path 8309",
    d: "M165.393,24.974l-.552-.552a.78.78,0,0,0-1.1,0l-2.683,2.683V9.516a.78.78,0,0,0-.78-.78h-.78a.78.78,0,0,0-.78.78v17.59l-2.683-2.683a.78.78,0,0,0-1.1,0l-.552.552a.78.78,0,0,0,0,1.1l4.957,4.957a.78.78,0,0,0,1.1,0l4.957-4.957A.78.78,0,0,0,165.393,24.974Z",
    transform: "translate(-142.122 -8.346)",
    fill: "#3f2566"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscSort);
export default __webpack_public_path__ + "static/media/asc-sort.6f54979f290ee1c48761bb2fe38d92e0.svg";
export { ForwardRef as ReactComponent };